import React from 'react';
import EmbedPlayer from '../../Embed/EmbedPlayer';

const View = (props) => {
  const { href, type } = props.data;
  const uid = href?.[0]?.UID;

  if (!uid) {
    return null;
  }

  return <EmbedPlayer uid={uid} type={type} />;
};

export default View;
